import React, { ReactElement } from 'react';

import { useCategoriaEvento } from '../reducers';
import GroupedMultipleSelect from './GroupedMultipleSelect';
import { CategoriaEvento } from '../api/auto-types';

interface ownProps {
  name: string,
  displayName?: string,
  help_text?: string | ReactElement,
}


type MacroEvento = "gas" | "stage" | "olifis"


const eventoToColor = (macro: MacroEvento) => {
  return {
    "olifis": "olifis",
    "gas": "emerald",
    "stage": "teal",
  }[macro]
}


const categoriaEventoToMacroEvento: (cat: CategoriaEvento["tipologia"]) => MacroEvento = cat => {
  return {
    "gas": "gas",
    "scrittostage": "stage",
    "testinizialestage": "stage",
    "preteststage": "stage",
    "1liv": "olifis",
    "2liv": "olifis",
    "seni": "olifis",
    "tstipho": "olifis",
  }[cat] as MacroEvento
}

const CategoriaEventoSelector = (props: ownProps) => {
  const categoriaEvento = useCategoriaEvento(props);

  return (
    <GroupedMultipleSelect
      {...props}
      elements={categoriaEvento}
      getGroup={cat => categoriaEventoToMacroEvento(cat.tipologia)}
      groupToColor={eventoToColor}
      displayGroup={group => ({ gas: 'Gara a squadre', stage: 'Stage', olifis: 'Olimpiadi di Fisica' }[group])}
      displayElem={comp => comp.nome}
    />
  )
}

export default CategoriaEventoSelector;
